import React from 'react';
import OnDemandVideoIcon from '@material-ui/icons/OndemandVideo';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '80%',
    border: `1px solid ${theme.palette.common.black}`
  },
  header: {
    padding: theme.spacing(0.5),
    background: 'linear-gradient(to right, #88018A, #D500D8)',
    fontWeight: 400,
    color: theme.palette.common.white,
  },
  content: {
    color: theme.palette.common.black,
    padding: theme.spacing(1, 2),
    margin: 0
  },
  iconStyles: {
    height: '20px',
    width: '20px',
    marginRight: theme.spacing(1)
  }
}));

const RequestLiveShowMessage = ({ message }) => {
  const classes = useStyles();
  let requestLiveShowMessage;

  if (message.details.liveShowTimestamp && message.details.modelName) {
    const formattedTime = moment(message.details.liveShowTimestamp).format('LLL');
    requestLiveShowMessage = `Hey ${message.details.modelName}! I'm interested in your recording from ${formattedTime}`;
  }


  return (
    <Box className={classes.container}>
      <Box
        className={classes.header}
        display="flex"
        alignItems="center"
      >
        <OnDemandVideoIcon className={classes.iconStyles} />
        <span>Request Live Show</span>
      </Box>
      <p className={classes.content}>
        {requestLiveShowMessage}
      </p>
    </Box>
  )
}

export default RequestLiveShowMessage;
